import { storage, getBrowserEnv } from "@/utils";
const DOT_H5_NOLOGIN_LOG =
  "https://dotdata.knowbox.cn/data/data/dot-h5-nologin-log"; // 未登录状态下打点接口
const env = getBrowserEnv();
const envValue = env.isWechatMiniProgram ? 1 : env.isApp ? 2 : env.isWx ? 3 : 4; // 获取环境

(function () {
  const productID = 2; //对应产品ID
  /**
   * 请求
   * @param {*} url  请求地址
   * @param {*} method  请求方法
   * @param {*} data  请求参数
   * @returns
   */
  const request = async (url, method, data) => {
    try {
      const headers = new Headers();
      if (method.toLowerCase() === "post") {
        headers.append("Content-Type", "application/x-www-form-urlencoded");
      }

      const options = {
        method,
        headers,
        body: data ? new URLSearchParams(data) : undefined,
      };
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return await response.text();
    } catch (error) {
      return Promise.reject(error);
    }
  };
  /**
   * 打点
   * @param {*} passData  打点数据
   * @param {*} cb  回调
   */
  const _dot = async (passData, cb) => {
    if (!passData.actionCode) {
      throw new Error("actionCode is required");
    }
    const actionCode = passData.actionCode;

    delete passData.actionCode;

    const uuid = storage.get("uuid") || ""; // 获取从小程序传递并存储在本地的uuid
    const scene = storage.get("scene") || ""; // 获取从小程序传递并存储在本地的自定义scene
    const wxScene = storage.get("wxScene") || ""; // 获取从小程序传递并存储在本地的微信scene
    const teacherId = storage.get("userInfo")?.teacherId || ""; // 获取老师ID
    const source = storage.get("sourceDevice") || storage.get("channel") || "";

    passData.extJson = passData.extJson || {};
    passData.extJson.scene = scene; // 扩展字段中添加小程序中携带的自定义scene值
    passData.extJson.wxScene = wxScene; // 扩展字段中添加小程序中携带的场景值
    passData.extJson.env = envValue; // 1=>小程序，2=>小盒老师APP，3=>微信内打开H5，4=>其他
    passData.extJson.teacherId = teacherId; // 扩展字段添加老师ID
    passData.extJson.source = source; // 扩展字段添加来源

    /**
     * actionTime	string	动作时间，格式为“yyyy-MM-dd HH:mm:ss”，日期和时间之间有英文状态下的一个空格
     * UserId long	用户ID
     * ProductId	string	产品ID(1，作业盒子中学；2，作业盒子小学；3，单词部落)
     * AppVersion	string	app的版本号
     * AppSource	string	app的source，同api接口中的source
     * AppChannel	string	app的channel，同api接口中channel
     * pageCode	string	当前页面编码，暂时为空
     * pageFrom	string	来源页面编码，暂时为空
     * deviceType	string	设备类型，同api接口中的deviceType
     * operatingSystem	string	设备型号，同api接口中的deviceVersion
     * deviceUniqueIdentifier	string	设备ID，同api接口中的deviceID
     * extensionJson	string	业务扩展信息，json格式，确保json中不会出现竖线分隔符。如果没有业务扩展信息，则为空。
     *    1. scene	string	  小程序中携带的场景值
     *    2. wxScene	string  	小程序中携带的自定义scene值
     *    3. teacherId	string	老师ID
     *    4. env string	环境,
     * actionCode	string	动作编码
     */
    const data = [
      "",
      "",
      productID,
      "4500",
      "h5Teacher",
      source,
      passData.pageCode || "",
      encodeURIComponent(window.location.href),
      "",
      "",
      uuid,
      JSON.stringify(passData.extJson),
      actionCode,
    ].join("|");

    const params = {
      data,
      version: "4500",
      t: +new Date(),
    };
    await request(DOT_H5_NOLOGIN_LOG, "POST", params).catch((e) => e);

    cb && cb();
  };
  window.Record = {
    _dot,
  };
})();
